import { OperatorConfig } from "..";

// PROD
const sourcesConfig: OperatorConfig = {
  backoffice: {
    display: {
      "feature.enterprise": false,
      "sidebar.menu.management.calendar": false,
      "sidebar.menu.management.bookings": false,
      "sidebar.menu.management.incidents": false,
      "sidebar.menu.management.visits": false,
      "feature.dashboards.realtime_occupancy": false,
      "feature.dashboards.realtime_incidents": false,
      "feature.dashboards.incidents": false,
      "feature.dashboards.occupancy": false,
    },
  },
};

export default sourcesConfig;
